import React from 'react';
import PropTypes from 'prop-types';
import Popover from './Popover';
import * as config from '../settings/global'
import DraftHTML from './draftEditor/export/DraftHTML';
import { dispatchNotification } from "../layouts/app/components/notificationSystem/notifications";
import Button from "./ripple/Button";
import { NAV_EXPLAINS } from "../settings/navigation";

const FEATURES_STYLES = {
    'unstyled' : 'feature-description__unstyled',
    'paragraph' : 'feature-description__paragraph',
}

export class Checkbox extends React.Component {

    // check PropTypes from the bottom of Component to avoid errors
    // description is displayed only if  it has some props
    // onChange function can be used as onClick too (need to send its props where component is used)
    // isChecked verification need to be sent where component is used
    // className defines custom additional class
    // suggested shows user if we recommend to check it :
    //  - no, it's not only for deploy pages, so it don't violate the principles of a dumb component
    // beforeDescription renders DOM elements between title and description. Takes ONLY arrays with DOM elements

    constructor(props) {
        super(props);

        this.state = {
            collapsed : true,
            height : undefined
        }
    }

    componentDidMount() {

        this.calculateDescriptionHeight();
        // if (!this.props.suggested) this.setState({collapsed : true}) // in case you wanna collapse/unfold features by default
        if (!this.props.collapsedProp) this.setState({collapsed: false});
        window.addEventListener('resize', this.handleResize)

    }

    handleResize = () => {
        if (!this.state.collapsed) {
            this.calculateDescriptionHeight();
        }
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        let {description, beforeDescription, link, collapsedProp} = this.props;
        let descriptionDataChanged = (
            description !== prevProps['description'] || beforeDescription !== prevProps['beforeDescription'] || link !== prevProps['link']
        );

        if (descriptionDataChanged || this.state.collapsed !== prevState.collapsed && !this.state.collapsed) {
            this.calculateDescriptionHeight();
        }

        if (prevProps.collapsedProp !== collapsedProp) {
            this.setState({collapsed: collapsedProp})
        }
        // throw to parent the collapsed state
        if (this.props.onToggleCollapse && this.state.collapsed !== prevState.collapsed) {
            this.props.onToggleCollapse(this.state.collapsed)
        }
    }

    calculateDescriptionHeight = () => {

        let elementInDom = this.description;
        let text = this.text;
        let before = this.before;
        let link = this.link;
        let getHeightOf = el => {
            let elStyle = el.currentStyle || window.getComputedStyle(el);
            return parseFloat(elStyle['margin-top']) + parseFloat(elStyle['margin-bottom']) + el.offsetHeight;
        };

        if (elementInDom) {

            let height = 0;

            if (text) height += getHeightOf(text);
            if (before) height += getHeightOf(before);
            if (link) height += getHeightOf(link);

            this.setState({height: height + 'px'});
        }
    };

    onChange = e => {
        this.props.onChange(e)
    };

    handleAdminIpInput = () => {
        this.props.handleAdminIpInput()
    };

    onArrowClick = e => {
        e.stopPropagation();
        e.preventDefault();
        if (this.props.handleAdminIpInput) {
            this.handleAdminIpInput();
        }
        this.setState({collapsed : !this.state.collapsed});
    };

    renderDescription = () =>{

        let {description, link, beforeDescription} = this.props;
        let height = this.state.collapsed ? '0px' : this.state.height;

        if (description) {
              return (
                  <div className='checkbox-custom__container__content__description'
                       style={{maxHeight: height}}
                       ref={description => this.description = description}
                  >
                      <div className='checkbox-custom__container__content__description__before'
                           ref={before => this.before = before}
                      >
                          {beforeDescription}
                      </div>
                      <div className='checkbox-custom__container__content__description__text'
                         ref={text => this.text = text}
                      >
                          {
                              typeof description === 'string'
                                  ? description
                                  : (
                                      typeof description === 'object'
                                      && !!description
                                      && !!description.blocks
                                      && !!description.blocks[0]
                                      && !!description.blocks[0]['text']
                                      &&
                                      <DraftHTML content={description} styles={FEATURES_STYLES}/>
                                  )
                          }
                      </div>
                      {
                          link &&
                          <p className='checkbox-custom__container__content__description__link-container'
                             ref={link => this.link = link}
                          >
                              Source:
                              <a className='checkbox-custom__container__content__description__link-container__link'
                                 href={link}
                                 onClick={event => event.stopPropagation()}
                                 target='_blank'
                              >
                                  {link}
                              </a>
                          </p>
                      }
                  </div>
              )
        }
    };

    renderExplain = () => {

        let {explain, code} = this.props;
        if (!explain) return null;
        let url = explain['url'];
        let includes = string => url.includes(string);
        let isExternal = includes('https://') || includes('http://') || includes('.com') || includes('.org');
        let isInternal = includes('explains/') && !isExternal; // external could possibly contain "explains/"

        if (!isExternal && !isInternal) {
            if (config.DEBUG) dispatchNotification({
               message: `Feature "${code}" contains invalid link ${url}. Link should start with "${NAV_EXPLAINS}/", "https://" or "http://"`,
               type: 'warning',
            });
            return null
        }

        if (isInternal && url.charAt(0) !== '/') url = '/' + url;

        let buttonProps = {
            className: 'checkbox-explain-button',
            icon: 'far-question-circle',
            displayType: 'text',
            visuals: {
                colorBasic: ['var(--colorFontInfo)']
            }
        }

        return (
            <div className='checkbox-custom__container__content__title__explain'>
                {
                    isExternal &&
                    <a
                        className='checkbox-custom__container__content__title__explain__link'
                        href={explain['url']}
                        target='_blank'
                    >
                        <Button onClick={e => e.stopPropagation()} {...buttonProps}/>
                        <i
                            className='fas fa-external-link-alt checkbox-custom__container__content__title__explain__link__external'
                            aria-hidden="true"
                        />
                    </a>
                }
                {
                    isInternal &&
                    <Button
                        {...buttonProps}
                        onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            explain['onClick'](explain['url']);
                        }}
                    />
                }
            </div>
        )
    }

    render() {

        let { text, name, isChecked, className, id, suggested, description, link, popover} = this.props;
        let checkStyle = isChecked ? ' checkbox-item-selected' : '';
        let collapseStyle = this.state.collapsed ? ' hide-checkbox-description' : '';
        let customClass = className ? ' ' + className  : '';
        let isLocked = this.props.locked ? ' checkbox-item-locked' : '';
        let popoverLink = this.props.popoverLink ? this.props.popoverLink : '';

        return (
            <label htmlFor={id} className={`checkbox-custom${checkStyle}${isLocked}${customClass}`} key={id}>
                <input id={id} type="checkbox" onChange={this.onChange} name={name} ref={el => this.input = el}/>
                <div className='checkbox-custom__container'>

                    <div className='checkbox-custom__container__icon'>
                        <i
                            className="checkbox-custom__container__icon__icon-checked far fa-check-square"
                            aria-hidden="true"
                        />
                        <i className="checkbox-custom__container__icon__icon-empty far fa-square" aria-hidden="true"/>
                    </div>

                    <div className={`checkbox-custom__container__content${collapseStyle}`}>

                        <div className='checkbox-custom__container__content__title'>
                            {
                                (description || link) &&
                                <i className="checkbox-custom__container__content__title__arrow fas fa-chevron-down"
                                   onClick={this.onArrowClick}
                                   aria-hidden="true"
                                />
                            }
                            <i
                                className="fas fa-lock checkbox-custom__container__content__title__locker"
                                aria-hidden="true"
                            />
                            {text &&
                            <h2 className='checkbox-custom__container__content__title__main' id={text}>
                                {text ? text : ' missing data'}
                            </h2>}
                            {this.renderExplain()}
                            {suggested &&
                            <div className='checkbox-custom__container__content__title__suggest'>recommended</div>}
                            {popover &&
                            <Popover ariaLabel="Help information"
                                     className='CheckboxPopover'
                                     link={popoverLink}
                            >
                                {popover}
                            </Popover>
                            }
                        </div>

                        {this.renderDescription()}
                    </div>
                </div>
            </label>
        );
    }
}

Checkbox.propTypes = {
    text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    name: PropTypes.string,
    className: PropTypes.string,
    isChecked: PropTypes.bool,
    suggested: PropTypes.bool,
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    link: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string,PropTypes.object]),
    beforeDescription: PropTypes.arrayOf(PropTypes.node)
};